import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { ErrorAPI } from 'api/Assessor/methods';
import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import GenericModal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';
import { clsx } from 'helpers/utils/HTMLUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Col,
  Row,
  TimesCircleIcon,
  ToastTypes,
  TrashIcon,
} from 'plataforma-fundacao-componentes';
import { useCallback, useContext, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssessorDeletarPauta } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import { useStyles } from './styles';

export interface IConfirmDeletarPautaModalProps extends IGenericModalProps {
  key: string;
  idPauta: number;
  idEvento: number;
  titulo: string;
  onDelete: () => void;
  presencialLiberada?: boolean;
}

export interface IConfirmDeletarPautaModal extends IModalProps {
  genericProps?: IConfirmDeletarPautaModalProps;
  modalsActionsClose: (key: string) => ModalsActionsClose;
  assembleiasAssessorDeletarPauta: (
    idEvento: number,
    idPauta: number,
    flgCienteDelecao: boolean,
    callbackSuccess?: () => void,
    callbackError?: (error: AxiosError<ErrorAPI>) => void
  ) => void;
}

const mapStateToProps = (state: IReducer) => {
  return {
    assembleia: state.assembleiasAssessor,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      modalsActionsClose,
      assembleiasAssessorDeletarPauta,
    },
    dispatch
  );

const ConfirmDeletarPautaModal = ({
  genericProps,
  open,
  modalsActionsClose,
  assembleiasAssessorDeletarPauta,
}: IConfirmDeletarPautaModal) => {
  const classes = useStyles();

  const [checked, setChecked] = useState<boolean>(false);

  const { showToast } = useContext(LayoutContext);

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      modalsActionsClose(genericProps.key);
    }
  }, [genericProps, modalsActionsClose]);

  const toDelete = useCallback(() => {
    if (genericProps?.idPauta) {
      assembleiasAssessorDeletarPauta(
        genericProps.idEvento,
        genericProps.idPauta,
        checked,
        () => {
          toast.success(translation.ConfirmDeletarPauta.succesDeletarPauta);
          genericProps.onDelete();
          toClose();
        },
        (error) => {
          showToast({
            pauseOnFocusLoss: true,
            theme: ToastTypes.Error,
            showStatusBar: true,
            timeout: 4000,
            label: languageValues.toasts.error.keyErrors(
              error!?.response!?.data!?.message
            ),
          });
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assembleiasAssessorDeletarPauta, genericProps, toClose, checked]);

  const handleChange = useCallback((event: any) => {
    setChecked(event.target.checked);
  }, []);

  return (
    <GenericModal
      open={open ?? false}
      title={translation.ConfirmDeletarPauta.title}
      content={
        <Grid container className={classes.root}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={clsx([
              classes.contentText,
              genericProps?.presencialLiberada ? 'check-content' : '',
            ])}
          >
            {genericProps?.presencialLiberada ? (
              <>
                <p>
                  Esta pauta já se encontra liberada na assembleia presencial.
                  Caso seja deletada, ela será excluída no presencial também, e
                  caso haja votos computados, estes serão deletados.
                </p>
                <FormControlLabel
                  style={{ marginLeft: '0', gap: 8 }}
                  labelPlacement='end'
                  control={
                    <Checkbox
                      color='primary'
                      checked={checked}
                      onClick={handleChange}
                    />
                  }
                  label={'Desejo prosseguir com a exclusão'}
                />
              </>
            ) : (
              <p>
                {translation.ConfirmDeletarPauta.confirmText(
                  genericProps?.titulo!
                )}
              </p>
            )}
          </Grid>
          <Row>
            <Col buttonActionsCol end>
              <Button
                theme={ButtonThemes.Default}
                onClick={toClose}
                leftIcon={<TimesCircleIcon />}
              >
                {translation.ConfirmDeletarPauta.cancelButton}
              </Button>
              <Button
                theme={ButtonThemes.Danger}
                onClick={toDelete}
                disabled={genericProps?.presencialLiberada && !checked}
                leftIcon={<TrashIcon />}
              >
                {translation.ConfirmDeletarPauta.confirmButton}
              </Button>
            </Col>
          </Row>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeletarPautaModal);
